import { RedoSingleDatePicker } from "@redotech/arbiter/date-picker/redo-single-date-picker";
import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import {
  RedoTimePicker,
  TimeOfDay,
} from "@redotech/arbiter/time/redo-time-picker";
import {
  dateToCurrentPlainDate,
  plainDateToCurrentDate,
} from "@redotech/util/temporal";
import { LabeledInput, LabelSize } from "../../../labeled-input";
import { INITIAL_START_TIME } from "../../discount-shared";

export function StartDateTimeField({
  startDate,
  setStartDate,
  startTime,
  setStartTime,
}: {
  startDate: Date | undefined;
  setStartDate: (date: Date | undefined) => void;
  startTime: TimeOfDay | null;
  setStartTime: (time: TimeOfDay | null) => void;
}) {
  return (
    <LabeledInput
      label={
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Start date & time (optional)
        </Text>
      }
      size={LabelSize.EXTRA_SMALL}
    >
      <Flex align="center" gap="sm">
        <RedoSingleDatePicker
          date={startDate ? dateToCurrentPlainDate(startDate) : undefined}
          setDate={(date) => {
            const newDate = date ? plainDateToCurrentDate(date) : undefined;
            setStartDate(newDate);
            if (!newDate && startTime) {
              setStartTime(INITIAL_START_TIME);
            }
          }}
          size="sm"
        />
        <RedoTimePicker
          disabled={!startDate}
          setValue={setStartTime}
          size="sm"
          value={startTime}
        />
      </Flex>
    </LabeledInput>
  );
}
